import React from "react";
import _ from "lodash";
import { connect } from 'react-redux'

import withStyles from "@material-ui/core/styles/withStyles";
import styles from "../styles";
import {getErrorMessage} from "../../../../../../../../../../../utils/utils";
import {CircularProgress, Container} from "@material-ui/core";
import {InvestmentStrategiesResource} from "../../../../../../../../../../../utils/api";
import {
  displayErrorSnackBar,
  displayWarningSnackBar
} from "../../../../../../../../../../../components/SnackbarProvider/actions";
import InvestmentStrategiesList from '../../../../../../../../../../InvestmentStrategy/List/List'
import {InvestmentStrategyHandler} from "../../../../../../../../../utils";
import {DEFAULT_SELECT_PRODUCT_TABLE_ACTIONS_NAMES} from "../../../../../../../../../../../utils/constants";
import {SelectableInstrumentsTable} from "../../../../../../../../../../../components/SelectForProductsComparisonModal/SelectForProductsComparisonModal";
import {musterPortfolioInstrumentsTableStructure} from "../../../../../../../../../../Modelportfolios/components/InstrumentsList/table-data";

import useStyles from "./styles";

function StrategySelection(props) {
  const {
    investmentStrategy,
    onInstrumentSelect,
    onSelectAll,
    selectedInstruments,
    onSourceSelect,
    sourceSelected,
  } = props;

  const classes = useStyles();

  const assetsTableDataSource = _.get(investmentStrategy, 'related_model_portfolio.assets') || [];

  const availableAssets = React.useMemo(() =>
    assetsTableDataSource.filter(asset => !asset.disabledByFilter),
    [investmentStrategy]);

  const handleAllSelected = () => {
    if (onSelectAll){
      const selected = selectedInstruments || [];
      let assets = [...availableAssets];
      if (selected.length === assets.length) {
        assets = []; // unselect all
      }

      onSelectAll(assets)
    }
  };

  return (
    <Container className={classes.pageContainer} style={{height: 'auto'}}>
      <SelectableInstrumentsTable
        container={investmentStrategy || {}}
        ContainerProps={{
          enabled: true,
          selectable: !!onSourceSelect,
          path: 'INVESTMENT_STRATEGIES_OVERVIEW',
          checked: sourceSelected,
          onChange: onSourceSelect,
          classes: {
            containerName: classes.containerName,
            containerCheckbox: classes.containerCheckbox
          }
        }}
        instruments={assetsTableDataSource}
        InstrumentsProps={{
          enabled: true,
          selected:  selectedInstruments || [],
          handleSelectAll: !!onSelectAll ? handleAllSelected : null,
          handleSelect: onInstrumentSelect,
          tableStructure: musterPortfolioInstrumentsTableStructure,
          totalInstrumentsCount: availableAssets.length,
          tableClasses: classes
        }}
      />
    </Container>
  )
}

function InvestmentStrategySelection(props) {
  const {
    classes,
    selectedItem,
    onDetailsClick,
    onSelectAll,
    onInstrumentSelect,
    depot,
    hideTitle,
    dataService,
    selectedInstruments,
    forceAllAssetsSelection,
    onSourceSelect,
    sourceSelected,
    directAddingPossible,
    onListItemSelect,
    isItemSelected,
  } = props;

  const [loading, setLoading] = React.useState(false);
  const [skipDetails, setSkipDetails] = React.useState(false)

  const strategiesHandler = React.useMemo(() => {
    if(!dataService) {
      return undefined;
    }
    return new InvestmentStrategyHandler(undefined, dataService._target_market)
  }, [depot, dataService])

  /**
   * Get investment strategy details.
   * @param investmentStrategyId Investment strategy identifier
   * @param skipDetails Should we display details screen, or not.
   * @returns {Promise<void>}
   */
  const handleDetailsClick = async (investmentStrategyId, skipDetails) => {
    setLoading(true);
    setSkipDetails(skipDetails);
    try {
      let investmentStrategy = await InvestmentStrategiesResource.at(`${investmentStrategyId}/`).get();

      const assets = _.get(investmentStrategy, 'related_model_portfolio.assets') || []

      if (!assets.length) {
        props.dispatch(displayWarningSnackBar('Für dieses Portfolio sind leider nicht alle Daten vorhanden.'))
      } else {
        forceAllAssetsSelection && onSelectAll(assets);
        onDetailsClick({
          ...investmentStrategy,
          assets,
          isInvestmentStrategy: true
        }, skipDetails);
      }
    } catch (error) {
      props.dispatch(displayErrorSnackBar(getErrorMessage(error)))
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {loading && (
        <div className={classes.loadingContainer}>
          <CircularProgress className={classes.loadingIndicator}/>
        </div>
      )}
      {!loading && (
        <>
          {selectedItem && !skipDetails && (
            <StrategySelection
              investmentStrategy={selectedItem}
              onInstrumentSelect={onInstrumentSelect}
              onSelectAll={onSelectAll}
              selectedInstruments={selectedInstruments}
              onSourceSelect={onSourceSelect}
              sourceSelected={sourceSelected}
            />
          )}
          {(!selectedItem || skipDetails) &&
            <InvestmentStrategiesList
              hideTitle={hideTitle}
              extraParams={depot && {custodian_id: depot.bankCompanyId}}
              viewOnly
              handleEditClick={handleDetailsClick}
              strategiesHandler={strategiesHandler}
              directAddingPossible={directAddingPossible}
              actionsNames={DEFAULT_SELECT_PRODUCT_TABLE_ACTIONS_NAMES}
              isItemSelected={isItemSelected}
              onItemSelect={onListItemSelect}
            />}
        </>
      )}
    </>
  )
}

InvestmentStrategySelection.defaultProps = {
  forceAllAssetsSelection: true
}

export default connect()(withStyles(styles)(InvestmentStrategySelection));